export const JumpToID = (id) => {
    const element = document.getElementById(id);
    if (element) {
    //    scroll so 200px from top of page
        const y = element.getBoundingClientRect().top + window.pageYOffset - 100;
        window.scrollTo({top: y, behavior: 'smooth'});

    }
        
};